import React from "react";
import { arrayOf, exact, number, shape, string } from "prop-types";
import styles from "./RegionLoadingView.module.styl";
import { Card, Heading } from "uikit/components";
import { toShortDateStringLocale } from "utils";
import RegionLoadingSummaryCard from "components/loading/RegionLoadingSummaryCard/RegionLoadingSummaryCard";
import RegionLoadingRow from "components/loading/RegionLoadingRow/RegionLoadingRow";

export default function RegionLoadingView({ regionId, data }) {
    const weekStartDate = toShortDateStringLocale(data.reportDates.start);
    const weekEndDate = toShortDateStringLocale(data.reportDates.end);

    return (
        <>
            <Heading size={"h1"} className={styles.heading} name="region-loading-header">
                Загруженность спортивных объектов с {weekStartDate}. по {weekEndDate}.
            </Heading>
            {data.municipalities.length !== 0 ? (
                <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
                    <div className={styles.outForm}>
                        <RegionLoadingSummaryCard
                            regionData={data}
                            regionId={regionId}
                            info={"Показатель загрузки спортобъекта"}
                        />
                    </div>
                    <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
                        <div
                            className={styles.headingContainer}
                            data-test-name="region_loading_form"
                        >
                            <div>Муниципальные образования</div>
                            <div className={styles.sportObjectsCount}>
                                Кол-во спортивных объектов
                            </div>
                            <div className={styles.loading}>Загруженность</div>
                        </div>
                        <div>
                            {data.municipalities?.map((item) => (
                                <RegionLoadingRow
                                    key={item.municipalityId}
                                    regionId={regionId}
                                    regionLoading={item}
                                />
                            )) ?? []}
                        </div>
                    </Card>
                </Card>
            ) : (
                <div className={styles.noItemContainer}>
                    <RegionLoadingSummaryCard
                        regionId={regionId}
                        regionData={data}
                        info={"Показатель загрузки спортобъекта"}
                    />
                </div>
            )}
        </>
    );
}

RegionLoadingView.propTypes = {
    regionId: number.isRequired,
    data: exact({
        reportDates: shape({
            start: string.isRequired,
            end: string.isRequired,
        }).isRequired,
        municipalityName: string.isRequired,
        municipalities: arrayOf(
            shape({
                municipalityId: number,
                municipalityName: string,
                loading: number,
                sportObjectsCount: number,
            }),
        ),
    }),
};
